import { LOCALES, KEYS } from '../constants';

const trTRTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_TURKISH_TR] : {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"İş Ortağı Rolü",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"Entegratör",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"Sağlayıcı",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"İş Ortağı Seviyesi",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"İş Ortağı Uzmanlığı",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:" Cisco Destekli Servis",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"İş Ortağı Adı",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"Konum",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"Ülke",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"İş Ortağı Adı Anahtar Kelimesi",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"İş Ortağı Adı Anahtar Kelimeleri",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"Sıralama",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"Uzmanlıklar",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"İş Ortağı Uzmanlıkları",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"Sağlayıcı Düzeyi ve Cisco Destekli Hizmetler",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"gold düzeyi sağlayıcı",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"premier düzeyi sağlayıcı",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"select düzeyi sağlayıcı",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"Yardım alın",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"Fiyat teklifi isteyin",
    [KEYS.L18N_KEY_LABEL_OPEN ]:" Aç",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"Genişlet",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"Daralt",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"Ülke/bölge seçin",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"Rol seçin",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"Uzmanlık alanları seçin",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"Cisco Destekli Hizmetler seçin",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"Uzmanlık Seçin",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"Seviye Seçin",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"İş Ortağı Ülkesi/Bölgesi",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"Entegratör Düzeyleri",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"Sağlayıcı Düzeyleri",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"Entegratör Uzmanlıkları",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Cisco Destekli Hizmetler",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"İş Ortağı Adları",
    [KEYS.L18N_KEY_LABEL_BACK ]:"Geri",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"Tüm sonuçlar",
    [KEYS.L18N_KEY_LABEL_ALL ]:"Tümü ",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"Kaydedildi",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"İş Ortaklarım",
    [KEYS.L18N_KEY_LABEL_ADD ]:"Ekle",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"Kaldır",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"Karşılaştırmak için ekle ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"En az bir tane daha seçin",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"Seçilenleri karşılaştır ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"Karşılaştırıcıdan kaldır",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"Karşılaştır",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"İş Ortağı Seviyesi",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"İşlem devam ediyor",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"sonuç",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"sonuç",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"Sonuç yok",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"sonuç",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"sonuç",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"Şu konumda sonuç yok:",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"Önceki",
    [KEYS.L18N_KEY_LABEL_PREV ]:"Önceki",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"Sonraki",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"Kaydet",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"Uzmanlık",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"Genel Bakış",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"bir Cisco",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"Entegratörler müşterilerimiz için baştan sona çözümler geliştirmektedir. Öncelikli olarak perakende satış yaparlar, ancak müşterilerin işle ilgili sorunlarını çözmek için kendi uzmanlıklarından yararlanırlar",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"Sağlayıcılar yönetilen çözümler ve bulut çözümleri sunan uzmanlardır. Müşteriler çözümleri kullanma yöntemlerinde daha fazla esneklik ararlarken sağlayıcıların pazardaki önemi gittikçe artmaktadır.",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"Geçmiş aramalar",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"Geçmiş arama",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"Roller ",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"Teknoloji",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"Endüstriler",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"Entegratörler",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"Sağlayıcılar",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"Diğer",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"Diğerleri",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"Kaydedilmiş başka iş ortağı yok",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"Kaydedilmiş entegratör yok",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"Kaydedilmiş sağlayıcı yok",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"ihtiyaca göre filtrele",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"birleşik ölçütlere göre ara",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"konuma göre ara",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"Dünya genelinde hizmet sunan 1 İş ortağı mevcut",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"Dünya genelinde hizmet sunan",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"iş ortağı mevcut",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"Hizmet sunan iş ortağı yok",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"Şu konumda hizmet sunan 1 iş ortağı mevcut:",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"iş ortağı şu konumda hizmet sunuyor:",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"Şu konumda hizmet sunan iş ortağı yok:",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"Konumu Değiştir",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"İhtiyaca göre filtrele",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"Arama",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"ada, seviyeye ve uzmanlığa göre",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"seçildi",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"Eşleşme bulunamadı",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"Sıra yukarı",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"Sıra aşağı",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"Ad yukarı",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"Ad aşağı",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"Oturum açmak gerekiyor",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"Bu işlemi yapabilmek için oturum açmalısınız",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"Arama yenilenemedi",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"Oturum Aç",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"İş ortağı başarıyla kaydedildi",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"İş ortağı kaydedilemedi",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"İş ortağı başarıyla kaldırıldı",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"İş ortağı silinemedi",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"Ad, seviye veya uzmanlığa göre arama yapmak için bir anahtar kelime yazın",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"Geliştiriciler Cisco teknolojisiyle çalışacak şekilde özel olarak hazırlanmış yazılımlar ve donanım çözümleri oluşturan uzmanlardır. Bu şekilde, istenen sonuçları sunmak üzere sistemleri birleştiren benzersiz çözümler oluştururlar.",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"Danışmanlar sektörle ilgili kapsamlı bilgiye sahip uzmanlardır. İşletmelere, karşılaştıkları karmaşık zorluklara yönelik çözümler keşfetmelerinde yol gösterirler.​",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"Çok Yönlü İş Ortağı",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"Alfabetik",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"En Fazla Uzmanlık",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"Geliştirici",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"Danışman",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"Filtreler",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"Filtrele",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"İş Ortağı Uzmanlığı",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"Yok say",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"Uzmanlığı ",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"Uzmanlıklar",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"Açıklama yapılmadı.",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"Hakkında",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"Net karşılaştırıcı",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"İş Ortağı Karşılaştırma",
    [KEYS.L18N_KEY_LABEL_ROLE]:"Rol",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"Teknolojik Odak",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"Açıklama",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"Dil Seçimini Yapın",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"Oturumu Kapat",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"Kapsayıcı İş Ortağı",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Cisco Hakkında",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Bize Ulaşın",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Kariyer",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "İş Ortaklarımızla Tanışın",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Geri Bildirim",
    [KEYS.L18N_KEY_LABEL_HELP]: "Yardım",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Şartlar ve Koşullar",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Gizlilik bildirimi",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Çerezler",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Ticari Markalar",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Tedarik Zinciri Şeffaflığı",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Site Haritası",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Cisco Hakkında",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Bize Ulaşın",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Kariyer",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "İş Ortaklarımızla Tanışın",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Geri Bildirim",
    [KEYS.L18N_KEY_LABEL_HELP]: "Yardım",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Şartlar ve Koşullar",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Gizlilik Bildirimi",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Çerezler",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Ticari Markalar",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Tedarik Zinciri Şeffaflığı",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Site Haritası",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "Nasıl Satın Alınır",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "Ortaklar",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "Ürünler ve Hizmetler",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "Çözümler",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "Destek",
    [KEYS.L18N_KEY_LABEL_LEARN]: "Öğrenin",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "Cisco'yu Keşfedin",
    [KEYS.L18N_KEY_LABEL_MENU]: "Menü",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "Kapat",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "Daha fazlasını görün",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "Daha az görün",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "Hesabınız yok mu?",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "kaydolun"
  }
});

export default trTRTranslations;
